// extracted by mini-css-extract-plugin
export default {"display":"Detail_display__9Wtgo","text":"Detail_text__q1Fwp","subtext":"Detail_subtext__5siVO"};